module.exports = __webpack_public_path__ + "img/119.6868d409.jpg";